import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../components/auth/auth.selector";
import DPStructure from "../../../components/discount-payments/DPStructure";

const DiscountPayments = () => {
  const userInfoData = useSelector(selectUser);

  return <DPStructure userInfoData={userInfoData} />;
};

export default DiscountPayments;
